import { useState } from "react";
import Input from "heroic-ui-library/dist/components/Input";
import openEye from "../../assets/002-eye.png";
import closeEye from "../../assets/001-hidden.png";

type Props = {
  pinCode: string;
  setPinCode: (value: string) => void;
  className?: string;
  placeholder?: string;
};
export default function PINField({
  pinCode,
  setPinCode,
  className,
  ...props
}: Props) {
  const [show, setShow] = useState(false);

  return (
    <div className="w-full flex items-center relative">
      <h1 className="font-acme text-4xl mr-2 mt-1">PIN</h1>
      <Input
        value={pinCode}
        onChange={(e) => setPinCode(e.currentTarget.value)}
        placeholder="Enter the pin"
        maxLength={6}
        {...props}
        className={"text-lg w-full " + className}
        type={show ? "text" : "password"}
      />
      <img
        className="w-8 ml-2 cursor-pointer absolute right-4 top-3"
        src={show ? openEye : closeEye}
        onClick={() => setShow(!show)}
      />
    </div>
  );
}
